module.exports = __webpack_public_path__ + "img/dstv-error-fix-2.487f6a3b.jpg";